<template>
  <v-dialog v-model="dialog" persistent width="600">
    <v-card>
      <!-- Cabecera del formulario -->

      <v-card-title class="headline">
        <v-flex xs9>
          <v-icon>{{ form.id ? "edit" : "add" }}</v-icon>
          {{
            form.id ? "Editar Curso Capacitacion" : "Crear Curso Capacitacion"
          }}
        </v-flex>
        <v-spacer></v-spacer>
        <v-btn icon @click.native="close()">
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>

      <!-- Cuerpo del formulario -->
      <v-form @submit.prevent="save" v-model="valid" ref="form" lazy-validation>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              
              <v-flex md6>
                <v-text-field
                  label="Denominación del Curso"
                  required
                  v-model="form.curso"
                  :rules="$validate(['required'])"
                  maxlength = "500"
                ></v-text-field>
              </v-flex>
              <v-flex xs6>
                <v-autocomplete
                  v-model="form.id_institucion"
                  :items="instituciones"
                  item-text="nombre_institucion"
                  :item-value="val => parseInt(val.id)"
                  label="Institución Académica"
                  required
                  :rules="$validate(['required'])"
                ></v-autocomplete>
              </v-flex>
            </v-layout>
            <v-layout wrap>
              <v-flex xs4>
                <v-text-field
                  name="label"
                  type="number"
                  min="0"
                  label="Duración en horas"
                  v-model="form.duracion_horas"
                  autofocus
                  :rules="[
                    v => {
                      if (v == null || v == '') {
                        return 'El campo es obligatorio.';
                      }
                      if (v < 0) {
                        return 'El número no tiene que ser negativo.';
                      }

                      return true;
                    }
                  ]"
                  required
                ></v-text-field>
              </v-flex>
              <v-flex xs4>
                <v-select
                  value="anios"
                  :items="anios"
                  type="year"
                  item-value="id"
                  item-text="valor"
                  label="Año"
                  v-model="form.anio"
                  autofocus
                  :rules="$validate(['required'])"
                  required
                ></v-select>
              </v-flex>
              <v-flex xs4>
                <v-select
                  :items="niveles"
                  :item-value="val => parseInt(val.id)"
                  item-text="valor"
                  label="Nivel de Conocimiento"
                  v-model="form.id_parametro_nivel"
                ></v-select>
              </v-flex>
              <v-flex xs4>
                <v-select
                  :items="certificados"
                  :item-value="val => parseInt(val.id)"
                  item-text="valor"
                  label="Certificado"
                  v-model="form.id_parametro_tipo_certificado"
                  :rules="$validate(['required'])"
                  required
                ></v-select>
              </v-flex>
              <v-flex xs4>
                <v-text-field
                  type="number"
                  name="label"
                  label="Calificación"
                  v-model="form.calificacion"
                  autofocus
                  :rules="[
                    v => {
                      if (v < 0) {
                        return 'El número no tiene que ser negativo.';
                      }
                      if (v > 100) {
                        return 'El número no tiene que mayor a 100.';
                      }

                      return true;
                    }
                  ]"
                ></v-text-field>
              </v-flex>
              <v-flex>
                <input
                  id="input"
                  type="file"
                  @change="handleFileUpload()"
                  ref="file"
                  accept="image/*, application/pdf"
                  :rules="$validate(['required'])"
                  required
                />
                <p class="red--text body-1" v-if="error">
                  {{ mensjageerror }}
                </p>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <small class="error--text text-required"
            >* Los campos son obligatorios</small
          >
          <v-spacer></v-spacer>
          <v-btn @click.native="close()">
            <v-icon>cancel</v-icon> {{ $t("common.cancel") }}
          </v-btn>
          <v-btn
            color="primary"
            type="submit"
            :loading="loading"
            :disabled="!valid"
          >
            <v-icon dark>check</v-icon> {{ $t("common.save") }}
          </v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import validate from "@/common/mixins/validate"; // Importación de mixin de validaciones

export default {
  // Definición de mixins importados
  mixins: [validate],
  // Variables iniciales
  data() {
    return {
      dialog: false,
      form: {},
      valid: false,
      loading: false,
      niveles: [],
      anios: [],
      certificados: [],
      denominaciones: [],
      instituciones: [],
      documento_requisito: {},
      error: false,
      cargado: false,
      mensjageerror: ""
    };
  },
  mounted() {
    //llamando método contarAnios
    this.cargarNiveles();
    this.cargarCertificados();
    this.contarAnios(1980);
    this.cargarDenominacion();
    this.cargarInstituciones();

    this.$bus.$on("openDialogCrearActualizarCursosCapacitacion", item => {
      this.form = item;
      this.dialog = true;
    });
  },
  methods: {
     handleFileUpload() {
      if (this.$refs.file.value !== "") {
        this.cargado = true;
        const file = this.$refs.file.files[0];
        if (this.$refs.file.files[0].size > 3145728) {
          this.error = true;
          this.mensjageerror = "El archivo excede el tamaño permitido de 3MB.";
        } 
        else if (this.$refs.file.value === "") {
          this.error = true;
          this.mensjageerror = "Archivo invalido.";
        } else if (!(
          this.$refs.file.files[0].type.includes("application/pdf") ||
          this.$refs.file.files[0].type.includes("image/"))) {
          this.error = true;
          this.mensjageerror = "Formato no admitido por el sistema";
        } 
        else {
          this.error = false;
          this.mensjageerror = "";
        }
        this.file = file;
      }
    },

    async cargarDenominacion() {
      try {
        let respuesta = await this.$service.graphql({
          query: `
						 query{
              cursos{
                rows{
                  id
                  denominacion
                }
              }
            }
					`
        });

        this.denominaciones = respuesta.cursos.rows;
      } catch (error) {
        console.log(error);
      }
    },

    async cargarInstituciones() {
      try {
        let respuesta = await this.$service.graphql({
          query: `
						 query{
            institucions{
              rows{
                id
                nombre_institucion
              }
            }
              }
					`
        });

        this.instituciones = respuesta.institucions.rows;
      } catch (error) {
        console.log(error);
      }
    },
    async cargarNiveles() {
      try {
        let respuesta = await this.$service.graphql({
          query: `
						 query{
              params(tipo:"nivel"){
                rows{
                  id
                  valor
                }
              }
              }
					`
        });

        this.niveles = respuesta.params.rows;
      } catch (error) {
        console.log(error);
      }
    },
    async cargarCertificados() {
      try {
        let respuesta = await this.$service.graphql({
          query: `
						 query{
              params(tipo:"tipo_certificado"){
                rows{
                  id
                  valor
                }
              }
              }
					`
        });

        this.certificados = respuesta.params.rows;
      } catch (error) {
        console.log(error);
      }
    },

    //Método contar años

    contarAnios(y) {
      let anios = [];
      var currentYear = new Date().getFullYear();
      for (var i = currentYear; i >= y; i--) {
        anios.push({
          valor: i
        });
      }
      this.anios = anios;
    },

    close() {
      (this.form = {}), (this.loading = false);
      this.valid = false;
      this.cargado=false;
      this.$bus.$emit("closeDialog");
      this.dialog = false;
    },
    async save() {
      if (this.error) {
        return this.error;
      }

      if (this.$refs.form.validate()) {
       this.loading = true;
      if (this.error) {
        return this.error;
      }
        try {
          this.form.duracion_horas = parseInt(this.form.duracion_horas);
          this.form.calificacion = parseInt(this.form.calificacion);

          if (this.cargado) {
            let formData = new FormData();
            formData.append("file", this.file);
            let res = await this.$http.post(
              process.env.API_URL + "public/upload",
              formData
            );
            this.form.url_documento = res.data;
          }

          if (this.form.id) {
            const id = this.form.id;
            delete this.form.id;
            delete this.form._user_created;
            delete this.form._user_updated;
            delete this.form._created_at;
            delete this.form._updated_at;
            delete this.form.parametro_nivel;

           
            if (!this.form.id_institucion) {
              this.form.id_institucion = parseInt(this.form.institucion.id);
            }
            //const curso = this.form.curso;
            const institucion = this.form.institucion;
            //delete this.form.curso;
            delete this.form.institucion;
            await this.$service.graphql({
              query: `
								mutation edit($id: ID!, $curso_capacitacion: EditCursoCapacitacion!){
                  cursoCapacitacionEdit(id: $id, curso_capacitacion: $curso_capacitacion){
                    id
									}
								}
                
							`,
              variables: {
                id: id,
                curso_capacitacion: this.form
              }
            });
            this.form.curso = curso;
            this.form.institucion = institucion;
          } else {
            if (!this.cargado) {
              this.error = true;
              this.mensjageerror = "Debe seleccionar un archivo.";
              this.loading = false;
              return false;
            } else {
              this.error = false;
              this.mensjageerror = "";
            }
            this.form.id_estado = 1;
            let user = this.$storage.get("user");
            if (this.$route.params.id) {
              this.form.id_persona = parseInt(this.$route.params.id);
            } else {
              this.form.id_persona = user.id_persona;
            }
            await this.$service.graphql({
              query: `
								mutation add($curso_capacitacion: NewCursoCapacitacion!){
									cursoCapacitacionAdd(curso_capacitacion: $curso_capacitacion){
										id
									}
								}
                
							`,
              variables: {
                curso_capacitacion: this.form
              }
            });
          }
        } catch (error) {
          console.log(error);
        }
        document.getElementById("input").value = "";
        this.$message.success();
        this.loading = false;
        this.close();
      }
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/admin/ficha_personal/dialogs/CrearActualizarCursoCapacitacion.vue